// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__2GFy5","selected":"Chip_selected__NK4PG"};